module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('multiple-choice'), _vm._v(" "), _c('email'), _vm._v(" "), _c('redirect'), _vm._v(" "), _c('text-step'), _vm._v(" "), _c('welcome')], 1)
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-53c1c708!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/step/config/Main.vue
 ** module id = 829
 ** module chunks = 1
 **/